import React from 'react';
import PageSEO from "@/components/common/PageSEO";
import Spacing from "@/components/common/Spacing";
import './legal-pages.css';

const PoliticaConfidentialitate: React.FC = () => {
  return (
	<>
	  <PageSEO section="legal" keyName="politica-confidentialitate" />
	  
	  <main className="legal-page">
		<div className="container">
		  <Spacing size={6} />
		  
		  <div className="legal-content">
			<h1>POLITICA DE CONFIDENȚIALITATE</h1>
			<p className="last-updated"><strong>Data ultimei actualizări: {new Date().toLocaleDateString('ro-RO')}</strong></p>

			<section>
			  <h2>1.1 Introducere</h2>
			  <p>Pixado (brand operat de ITastic.ro SRL) respectă confidențialitatea dumneavoastră și se angajează să protejeze datele personale pe care le colectăm și le procesăm. Această politică de confidențialitate explică cum colectăm, folosim, stocăm și protejăm informațiile dumneavoastră personale în conformitate cu Regulamentul General privind Protecția Datelor (GDPR).</p>
			</section>

			<section>
			  <h2>1.2 Date de contact și operator</h2>
			  <div className="contact-info">
				<p><strong>Operator de date:</strong> ITastic.ro SRL</p>
				<p><strong>Brand comercial:</strong> Pixado</p>
				<p><strong>Sediul:</strong> Timișoara, România</p>
				<p><strong>Email:</strong> contact@pixado.ro</p>
				<p><strong>Telefon:</strong> +40 745 371 620</p>
			  </div>
			</section>

			<section>
			  <h2>1.3 Platformele noastre</h2>
			  <p>Această politică se aplică pentru următoarele platforme:</p>
			  <ul>
				<li><strong>pixado.ro</strong> - Site-ul principal de prezentare și servicii</li>
				<li><strong>ccshop.pixado.ro</strong> - Platforma DEMO pentru demonstrarea capabilităților e-commerce (nu vinde produse reale)</li>
			  </ul>
			</section>

			<section>
			  <h2>1.4 Ce date personale colectăm</h2>
			  
			  <div className="data-category">
				<h3>Pentru pixado.ro (site principal):</h3>
				<ul>
				  <li><strong>Date de contact:</strong> Nume, email, telefon (doar prin formulare de contact)</li>
				  <li><strong>Date tehnice:</strong> Adresa IP, tipul browserului, sistemul de operare</li>
				  <li><strong>Date de tracking:</strong> Google Analytics 4, Facebook Pixel, TikTok Pixel</li>
				</ul>
				<p><strong>Important:</strong> Nu folosim localStorage pe site-ul principal.</p>
			  </div>

			  <div className="data-category">
				<h3>Pentru ccshop.pixado.ro (platforma DEMO):</h3>
				<ul>
				  <li><strong>Date de testare:</strong> Informații introduse pentru simularea cumpărăturilor (fictive)</li>
				  <li><strong>Date tehnice:</strong> IP, browser, OS, date stored în localStorage pentru funcționalitatea demo</li>
				  <li><strong>Date de tracking:</strong> Google Analytics 4, Facebook Pixel, TikTok Pixel</li>
				</ul>
				<p><strong>Important:</strong> ccshop.pixado.ro este doar o platformă DEMO - nu se efectuează tranzacții reale!</p>
			  </div>
			</section>

			<section>
			  <h2>1.5 Cum colectăm datele</h2>
			  <ul>
				<li><strong>Direct de la dumneavoastră:</strong> prin formulare de contact, înregistrări, comenzi</li>
				<li><strong>Automat:</strong> prin cookie-uri, pixel-uri de tracking și localStorage (doar pe ccshop.pixado.ro)</li>
				<li><strong>De la terți:</strong> platforme de social media (cu consimțământul dumneavoastră)</li>
			  </ul>
			</section>

			<section>
			  <h2>1.6 Scopurile prelucrării și temeiurile legale</h2>
			  <div className="table-responsive">
				<table className="legal-table">
				  <thead>
					<tr>
					  <th>Scop</th>
					  <th>Temeiul legal</th>
					  <th>Platformă</th>
					</tr>
				  </thead>
				  <tbody>
					<tr>
					  <td>Răspunderea la solicitări de contact</td>
					  <td>Interesul legitim</td>
					  <td>Ambele</td>
					</tr>
					<tr>
					  <td>Furnizarea serviciilor contractate</td>
					  <td>Executarea contractului</td>
					  <td>pixado.ro</td>
					</tr>
					<tr>
					  <td>Demonstrarea funcționalităților (demo)</td>
					  <td>Interesul legitim</td>
					  <td>ccshop.pixado.ro</td>
					</tr>
					<tr>
					  <td>Analytics și îmbunătățirea site-ului</td>
					  <td>Consimțământ</td>
					  <td>Ambele</td>
					</tr>
					<tr>
					  <td>Marketing digital și retargeting</td>
					  <td>Consimțământ</td>
					  <td>Ambele</td>
					</tr>
					<tr>
					  <td>Lead generation și consultanță</td>
					  <td>Interesul legitim</td>
					  <td>Ambele</td>
					</tr>
				  </tbody>
				</table>
			  </div>
			</section>

			<section>
			  <h2>1.7 Partajarea datelor cu terți</h2>
			  <p>Nu vindem, închiriem sau partajăm datele dumneavoastră personale cu terți, cu excepția:</p>
			  
			  <div className="data-category">
				<h3>Furnizori de servicii tehnice:</h3>
				<ul>
				  <li><strong>Google (Analytics 4):</strong> Analiză trafic website</li>
				  <li><strong>Meta (Facebook Pixel):</strong> Marketing și retargeting</li>
				  <li><strong>TikTok (TikTok Pixel):</strong> Marketing și retargeting</li>
				  <li><strong>Furnizori hosting:</strong> Stocarea și accesul la date</li>
				</ul>
			  </div>
			  
			  <ul>
				<li><strong>Autorități publice:</strong> când este cerut de lege</li>
				<li><strong>Transferuri de afaceri:</strong> în caz de fuziune sau achiziție</li>
			  </ul>
			</section>

			<section>
			  <h2>1.8 Transferuri internaționale</h2>
			  <p>Unele dintre datele dumneavoastră sunt procesate în afara UE de către:</p>
			  <ul>
				<li><strong>Google (SUA):</strong> Google Analytics 4 - Decizii de adecvare</li>
				<li><strong>Meta (SUA):</strong> Facebook Pixel - Clauze contractuale standard</li>
				<li><strong>TikTok (Singapore/SUA):</strong> TikTok Pixel - Măsuri de protecție adecvate</li>
			  </ul>
			</section>

			<section>
			  <h2>1.9 Perioada de păstrare</h2>
			  <ul>
				<li><strong>Date de contact (pixado.ro):</strong> 3 ani de la ultima interacțiune</li>
				<li><strong>Date demo (ccshop.pixado.ro):</strong> Șterse automat după închiderea sesiunii</li>
				<li><strong>Date de marketing:</strong> până la retragerea consimțământului</li>
				<li><strong>Date tehnice și analytics:</strong> conform politicilor Google/Meta/TikTok</li>
				<li><strong>localStorage (ccshop.pixado.ro):</strong> până la ștergerea manuală sau închiderea browserului</li>
			  </ul>
			</section>

			<section>
			  <h2>1.10 Drepturile dumneavoastră</h2>
			  <p>Aveți următoarele drepturi conform GDPR:</p>
			  <ul>
				<li><strong>Dreptul de acces:</strong> să obțineți o copie a datelor prelucrate</li>
				<li><strong>Dreptul la rectificare:</strong> să corectați datele inexacte</li>
				<li><strong>Dreptul la ștergere:</strong> să solicitați ștergerea datelor („dreptul de a fi uitat")</li>
				<li><strong>Dreptul la restricționare:</strong> să limitați prelucrarea</li>
				<li><strong>Dreptul la portabilitate:</strong> să primiți datele într-un format structurat</li>
				<li><strong>Dreptul la opoziție:</strong> să vă opuneți prelucrării</li>
				<li><strong>Retragerea consimțământului:</strong> oricând pentru prelucrările bazate pe consimțământ</li>
			  </ul>
			  <p>Pentru exercitarea drepturilor, contactați-ne la: <a href="mailto:contact@pixado.ro">contact@pixado.ro</a></p>
			</section>

			<section>
			  <h2>1.11 Măsuri de securitate</h2>
			  <p>Implementăm măsuri tehnice și organizaționale adecvate:</p>
			  <ul>
				<li><strong>Criptarea datelor:</strong> HTTPS/SSL pentru toate comunicările</li>
				<li><strong>Accesul restricționat:</strong> doar personalul autorizat</li>
				<li><strong>Monitorizarea regulată:</strong> loguri de securitate și auditări</li>
				<li><strong>Backup-uri sigure:</strong> stocarea redundantă și criptată</li>
				<li><strong>Formarea personalului:</strong> în protecția datelor și securitate</li>
			  </ul>
			</section>

			<section>
			  <h2>1.12 Reclamații și contact</h2>
			  <p>Pentru întrebări despre această politică sau pentru exercitarea drepturilor:</p>
			  <div className="contact-info">
				<p><strong>Email:</strong> <a href="mailto:contact@pixado.ro">contact@pixado.ro</a></p>
				<p><strong>Telefon:</strong> <a href="tel:+40745371620">+40 745 371 620</a></p>
			  </div>
			  
			  <p>Aveți dreptul să depuneți o reclamație la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP):</p>
			  <p><strong>Website:</strong> <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer">www.dataprotection.ro</a></p>
			</section>

			<section>
			  <h2>1.13 Modificări ale politicii</h2>
			  <p>Această politică poate fi actualizată periodic pentru a reflecta modificările în practicile noastre sau cerințele legale. Modificările importante vor fi comunicate prin email sau prin notificare pe site.</p>
			</section>
		  </div>
		  
		  <Spacing size={6} />
		</div>
	  </main>
	</>
  );
};

export default PoliticaConfidentialitate;